// Cor de fundo (fraca, não compete com o texto) pelo nível atual do aluno
// (campo `nivel` 1-4, vindo de getNivelAtualSubquery em backend/alunos.js —
// ver aluno_niveis, linha com data_fim IS NULL). Mesmo padrão de utils/areas.js.
// Sólidas (sem /opacidade) de propósito — usadas também em colunas sticky
// (ex.: "Inscrito" no Ajuste de Grade), que ficam por cima de outras células
// ao rolar a tabela horizontalmente. Com opacidade fracionada, o conteúdo por
// trás aparecia através da coluna fixa durante o scroll.
const COR_POR_NIVEL = {
  1: 'bg-amber-50 dark:bg-amber-950',
  2: 'bg-green-50 dark:bg-green-950',
  3: 'bg-blue-50 dark:bg-blue-950',
  4: 'bg-gray-100 dark:bg-gray-800',
};

// Sem nível cadastrado (null/undefined) não recebe cor nenhuma — mantém o
// fundo padrão do card de quem chamar.
export const corCardNivel = (nivel) => COR_POR_NIVEL[Number(nivel)] || '';
